import { Trans } from '@lingui/react';

function WorkingHours() {
  return (
    <div style={{ marginTop: "20px" }}>
      <h3><Trans id="working" /></h3>
      <p><Trans id="weekdays" /> 09:00 - 18:00</p>
      <p><Trans id="saturday" /> 09:00 - 15:00</p>
      <p><Trans id="sunday" /></p>
    </div>
  );
}

export default WorkingHours;
